import React from 'react';
import './ApiUserBadge.css';

export const API_USERS = {
  TS: { email: 'masterte0@tikwiz.com', className: 'api-user-ts' },
  DV: { email: 'dimos@tikwiz.com', className: 'api-user-dv' },
  Ria: { email: 'ria@tikwiz.com', className: 'api-user-ria' },
  Sai: { email: 'sai@tikwiz.com', className: 'api-user-sai' },
  MK: { email: 'miltos@tikwiz.com', className: 'api-user-mk' },
  JP: { email: 'fun3s@tikwiz.com', className: 'api-user-jp' },
  TWZ: { email: 'twz@tikwiz.com', className: 'api-user-twz' },
};

const EMAIL_TO_CODE = Object.entries(API_USERS).reduce((acc, [code, meta]) => {
  acc[meta.email.toLowerCase()] = code;
  return acc;
}, {});

export const getApiUserCode = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const direct = Object.keys(API_USERS).find((code) => code.toLowerCase() === raw.toLowerCase());
  if (direct) return direct;
  return EMAIL_TO_CODE[raw.toLowerCase()] || raw;
};

export const getApiUserMeta = (value) => {
  const code = getApiUserCode(value);
  return API_USERS[code] ? { code, ...API_USERS[code] } : null;
};

const ApiUserBadge = ({ value }) => {
  const meta = getApiUserMeta(value);
  if (!meta) {
    return <span>{value || '-'}</span>;
  }

  return (
    <span className={`api-user-badge ${meta.className}`} title={meta.email}>
      {meta.code}
    </span>
  );
};

export default ApiUserBadge;
